"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowComponent = void 0;
var callback_1 = require("../job/callback");
var file_descriptor_1 = require("./file-descriptor");
var source_1 = require("../job/source");
var FlowComponent = /** @class */ (function () {
    function FlowComponent(data) {
        this.specification = null;
        this.results = [];
        this.sources = [];
        this.successors = [];
        this.status = null;
        this.type = data.type;
        this.specification = data.specification;
        if (data.successors) {
            this.successors = data.successors;
        }
        if (data.callback) {
            this.callback = new callback_1.Callback(data.callback);
        }
        if (data.sources) {
            this.sources = data.sources.map(function (source) { return new source_1.Source(source); });
        }
        if (data.results) {
            this.results = data.results.map(function (fileDescriptor) { return new file_descriptor_1.FileDescriptor(fileDescriptor); });
        }
        this.status = data.status ? data.status : null;
    }
    return FlowComponent;
}());
exports.FlowComponent = FlowComponent;
//# sourceMappingURL=flow-component.js.map